import { render, staticRenderFns } from "./share-image.vue?vue&type=template&id=6056c713&scoped=true&"
import script from "./share-image.vue?vue&type=script&lang=js&"
export * from "./share-image.vue?vue&type=script&lang=js&"
import style0 from "./share-image.vue?vue&type=style&index=0&id=6056c713&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056c713",
  null
  
)

export default component.exports